var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"home",attrs:{"id":"app-home"}},[_c('system-tip'),_c('home-video'),_c('index-top-info'),_c('div',{staticClass:"main"},[_c('index-main-left'),_c('index-main-right')],1),_c('index-switch-company')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }